export default __webpack_public_path__ + "static/media/ai.02fd459c.png";